module.exports = __webpack_public_path__ + "img/map.7632256e.png";